import * as React from 'react'
import styled from 'styled-components'

import LegacyText, { PropsType as LegacyPropsType } from './Legacy/Text'
import compTheme from './theme'
import { ColorType, ThemePropsType } from './types'

export { Weight } from './Legacy/Text'

type TextTransformType =
  | 'none'
  | 'capitalize'
  | 'uppercase'
  | 'lowercase'
  | 'inherit'
  | 'initial'
  | 'unset'

export type PropsType = LegacyPropsType & {
  color?: ColorType
  letterSpacing?: string
  onClick?: () => void
  style?: object
  textTransform?: TextTransformType
}

const getColor = (props: PropsType & ThemePropsType) => {
  if (props.color != null) {
    return `color: ${props.theme.palette[props.color]}`
  }

  return `color: ${props.theme.textColor}`
}

const TextBlock = styled(LegacyText)<PropsType>`
  display: block;
  text-transform: ${(p) => p.textTransform};
  letter-spacing: ${(p) => p.letterSpacing};
  ${getColor};
  ${({ weight = 400 }) => `weight: ${weight}}`}
`

const Text = ({ children, size, ...rest }: PropsType) => {
  const fontSize = compTheme.fontSizes[size ?? 'md']

  return (
    <TextBlock size={fontSize} {...rest}>
      {children}
    </TextBlock>
  )
}

export default Text
